export default "/images/logo.png?db84166b95511e8dae164c60366cf0fa";